import styled from '@emotion/styled';
import { useSignPageControl } from '../../use-sign-page-control';
import AlreadyUser from './AlreadyUser';
import CheckEmailDuplicate from './CheckEmailDuplicate';
import NotUser from './NotUser';
import SignUpForm from './SignUpForm';
import { colors } from '@/constants/colors';

const SignUpBaseDiv = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px solid ${colors.lightGrey2};
  background-color: ${colors.white};
  border-radius: 15px 0 15px 15px;
  :after {
    position: absolute;
    top: -1px;
    right: 0;
    display: block;
    width: 50%;
    height: 1px;
    background-color: white;
    content: "";
  }
`;

const SignUp = () => {
  const { tabCodePage } = useSignPageControl();

  return (
    <SignUpBaseDiv>
      {tabCodePage === 'find' && <CheckEmailDuplicate />}
      {tabCodePage === 'up' && <SignUpForm />}
      {tabCodePage === 'alreadyuser' && <AlreadyUser />}
      {tabCodePage === 'notuser' && <NotUser />}
    </SignUpBaseDiv>
  );
};

export default SignUp;
